import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
// import { Chart } from "chart.js/auto";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);

export default function CardBarChart({ years = [], selectedGlobalYear, selectedGlobalMonth }) {
  const [pieData, setPieData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(selectedGlobalYear || new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(selectedGlobalMonth || new Date().getMonth() + 1);
  const [currency, setCurrency] = useState("");

  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

    useEffect(() => {
    setSelectedYear(selectedGlobalYear); // Sync with global year when it changes
  }, [selectedGlobalYear]);

    useEffect(() => {
    setSelectedMonth(selectedGlobalMonth);
  }, [selectedGlobalMonth]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
        console.log(data);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetExpenseMonthswise?groupId=${groupId}&year=${selectedYear}&months=${selectedMonth}`
        );
        const data = await response.json();
        setPieData(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    if (pieData.length === 0) {
      if (window.myPie) {
        window.myPie.destroy();
      }

      const ctx = document.getElementById("pie-chart").getContext("2d");
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      ctx.fillText(
        "No data found",
        ctx.canvas.width / 2,
        ctx.canvas.height / 2
      );
      return;
    }

    if (window.myPie) {
      window.myPie.destroy();
    }

    const config = {
      type: "pie",
      data: {
        labels: pieData.map((item) => item.expenseDescType),
        datasets: [
          {
            data: pieData.map((item) => item.totalExpenses),
            backgroundColor: [
              "#ffa426",
              "#4c51bf",
              "#48A5F4",
              "#FAC05E",
              "#1af09e",
              "#ad09a8",
              "#ad094d",
              "#f7ef07",
            ],
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: "Expense Distribution",
        },
        plugins: {
          datalabels: {
            display: true,
            color: ["white"],
            formatter: (value) => value,
            font: {
              weight: "bold",
              size: 16,
              family: "Courier",
            },
            align: "start",
            offset: -10,
            padding: {
              top: 10,
              bottom: 10,
            },
            labels: {
              title: {
                font: {
                  weight: "bold",
                },
              },
            },
          },
        },
      },
    };

    const ctx = document.getElementById("pie-chart").getContext("2d");
    window.myPie = new Chart(ctx, config);
  }, [pieData]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex items-center justify-between">
            <h2
              className="text-blueGray-700 text-xl font-semibold"
              style={{ fontSize: "1rem" }}
            >
              Monthly Expense ({currency})
            </h2>
            <div className="flex space-x-4">
              {" "}
              {/* Adjust space-x-4 to increase or decrease the gap */}
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="bg-white text-black border border-blueGray-600 rounded px-6 py-1 outline-none focus:outline-none md:w-32"
              >
                {years.map((yr) => (
                  <option key={yr} value={yr}>
                    {yr}
                  </option>
                ))}
              </select>
              <select
                className="bg-white-800 text-black border border-black-600 rounded px-3 py-1 outline-none focus:outline-none w-32"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}
                style={{ width: "115px" }}
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("en", { month: "long" })}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-350-px">
            <canvas id="pie-chart"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
